<ng-container *hasPermission="['ORGANIZATIONS_READ','ORGANIZATIONS_ALL', 'SAFESTREET_ADMIN']">
    <div class="container-fluid">
        <div class="page-title">
            <h2>Dettaglio ente - <b>{{detail_title}}</b></h2>
        </div>
        <form name="organizationForm" #f="ngForm" (ngSubmit)="onSubmit(f)">
            <div class="row">
                <div class="col-md-6 mb-3">
                    <label for="name" class="form-label">Name</label>
                    <input type="text" class="form-control" id="name" name="name" ngModel #name="ngModel"
                        [(ngModel)]="organization.name" required />
                </div>
                <div class="col-md-6 mb-3">
                    <label for="tenantId" class="form-label">Tenant ID</label>
                    <input type="text" class="form-control" id="tenantId" name="tenantId" ngModel
                        [(ngModel)]="organization.tenantId" required />
                </div>
            </div>

            <app-city-autocomplete idPrefix="organization" [showProvince]="false" [showPostalCode]="false"
                [city]="organization.cityName" (cityChange)="organization.cityName = $event"
                [cityId]="organization.cityId" (cityIdChange)="organization.cityId = $event">
            </app-city-autocomplete>

            <div class="row">
                <div class="col-md-6 mb-3">
                    <label for="organizationKey" class="form-label">Chiave estera BO</label>
                    <input type="text" class="form-control" id="organizationKey" name="organizationKey" ngModel
                        [(ngModel)]="organization.organizationKey" required />
                </div>
                <div class="col-md-6 mb-3">
                    <label for="bridgeId" class="form-label">Bridge</label>
                    <select class="form-select" id="bridgeId" name="bridgeId" [(ngModel)]="organization.bridgeId"
                        required>
                        <option [ngValue]="undefined"></option>
                        <option *ngFor="let bridge of bridges" [ngValue]="bridge.id">{{bridge.name}}</option>
                    </select>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6 mb-3">
                    <div class="auto-complete">
                        <label for="licenseName" class="form-label">Licenza</label>
                        <input type="text" class="form-control" id="licenseName" name="licenseName" ngModel
                            [(ngModel)]="licenseName" (keyup)="onLicenseKeyUp($event)"
                            pattern="{{licensePatternValidation}}" required />
                        <ul *ngIf="licenses && licenses.length>0">
                            <li *ngFor="let license of licenses" (click)="selectLicense(license)">
                                {{license.name}}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="d-flex justify-content-end  align-items-center mt-2 gap-2">
                <button type="button" class="btn btn-outline-secondary" (click)="back()">Indietro</button>
                <ng-template [hasPermission]="['ORGANIZATIONS_DELETE', 'ORGANIZATIONS_ALL','SAFESTREET_ADMIN']">
                    @if (organization.id !== undefined) {
                    <button type="button" (click)="confirmDelete()" class="btn btn-danger">
                        Elimina
                    </button>
                    }
                </ng-template>
                <ng-template [hasPermission]="['ORGANIZATIONS_UPDATE', 'ORGANIZATIONS_ALL','SAFESTREET_ADMIN']">
                    @if (organization.id !== undefined) {

                    <button type="submit" class="btn btn-primary">
                        Salva
                    </button>
                    }
                </ng-template>
                <ng-template [hasPermission]="['ORGANIZATIONS_CREATE', 'ORGANIZATIONS_ALL','SAFESTREET_ADMIN']">
                    @if (organization.id === undefined) {
                    <button type="submit" class="btn btn-primary">
                        Salva
                    </button>
                    }

                </ng-template>

            </div>
        </form>
        <app-confirm-alert [confirmationMessage]="'Eliminazione ente - '+confirmationMessage"
            [showConfirmationModal]="showConfirmationModal" (modalConfirm)="delete()" (modalCancel)="cancelDelete()">
        </app-confirm-alert>
    </div>
</ng-container>
